<span
  [innerHTML]="safeSvg"
  [style.width.px]="size"
  [style.height.px]="size"
  [style.color]="color"
  class="inline-block leading-none"
></span>
